import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 16px;
  `,
  disabled: css`
    opacity: 70%;
  `,
  orgNameContainer: css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding-top: 20px;
  `,
  schoolApproved: css`
    white-space: nowrap;
    font-size: 13px;
    color: ${colors.prussian};
  `,
  icon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33px;
    height: 24px;
    background-color: ${colors.lightPrussian};
    border-radius: 50px;
    padding: 4px 8px 4px 8px;
    color: ${colors.prussian};
  `,
  orgName: css`
    text-decoration: underline;
  `,
  disclaimer: css`
    margin-top: 16px;
    margin-bottom: 48px;
    background: ${colors.platinum};
    border-radius: 15px;
    padding: 16px;
  `,
};

export default styles;
